import * as React from 'react'

// import { useRef, useEffect } from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'steps-step'

/**
 * This is the component description.
 */
const Step = ({
  id,
  className:userClassName,
  step,
  number,
}) => (
  <div
    id={id}
    className={[
      baseClassName,
      componentClassName,
      userClassName,
      'grid span-grid',
    ]
      .filter((e) => e)
      .join(' ')}
  >
    <svg width="100" height="100" className="span-8 md-span-1">
      <circle cx="40" cy="40" r="40" fill="var(--main2)" stroke="var(--ui-lines)" strokeWidth="1" />
      <text x="40" y="42" textAnchor="middle" alignmentBaseline="middle" fill="var(--interactive)" fontSize="2em">
        {number}
      </text>
    </svg>
    <div className="md-start-2 start-1 span-grid">
      <p
        className="h4"
        style={{
          marginTop:0,
        }}
      >
        {step.title}
      </p>
      <p>
        {step.description}
      </p>
    </div>
  </div>
)

Step.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The description of the step the user is currently on
   */
  step:PropTypes.shape({
    title      :PropTypes.string,
    description:PropTypes.string,
  }),

  /**
   * The number of the step
   */
  number:PropTypes.number,
}

Step.defaultProps = {
  // color:'main',
}

export default Step
